module.exports = __webpack_public_path__ + "static/media/doremi_00174.4d8c2fc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/proj/doremi_00174.png
// module id = 259
// module chunks = 0